import { useEffect } from "react"
import {
  Overlay,
  PopupContainer,
  ImageSection,
  ContentSection,
  CloseButton,
  PopupEyebrow,
  PopupTitle,
  PopupText,
  PopupButton,
  PopupHelper,
} from "./Style"

interface PopupProps {
  title: string
  text: string
  buttonLabel: string
  onClick: () => void
  onClose: () => void
  imageUrl: string
}

const Popup = ({ title, text, buttonLabel, onClick, onClose, imageUrl }: PopupProps) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose()
    }
    document.addEventListener("keydown", closeOnEscape)
    return () => {
      document.body.style.overflow = previousOverflow
      document.removeEventListener("keydown", closeOnEscape)
    }
  }, [onClose])

  return (
    <>
      <Overlay onClick={onClose} />
      <PopupContainer role="dialog" aria-modal="true" aria-labelledby="estimate-popup-title" aria-describedby="estimate-popup-description">
        <CloseButton onClick={onClose} aria-label="Fermer la fenêtre" autoFocus>
          &times;
        </CloseButton>
        <ImageSection $image={imageUrl} />
        <ContentSection>
          <PopupEyebrow>Accompagnement personnalisé</PopupEyebrow>
          <PopupTitle id="estimate-popup-title">{title}</PopupTitle>
          <PopupText id="estimate-popup-description">{text}</PopupText>
          <PopupButton onClick={onClick}>{buttonLabel}</PopupButton>
          <PopupHelper>Votre demande sera transmise à notre équipe locale.</PopupHelper>
        </ContentSection>
      </PopupContainer>
    </>
  )
}

export default Popup
